import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class LocalStateService {
	private _pxLogin = false;

	constructor() {}

	public getPXLogin() {
		return this._pxLogin;
	}

	public setPXLogin(pxLogin: boolean) {
		this._pxLogin = pxLogin;
	}
}
